import { metricsConstants } from '../_constants/metrics.constants'

const INITIAL_STATE = {
  yearMetrics: null,
  rangeMetrics: null,
  driverMetrics: null,
  companyMetrics: null,
  companyProjectionMetrics: null,
  vehicleMetrics: null,
}

const metricsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case metricsConstants.GET_YEAR_METRICS:
      return {
        ...state,
        yearMetrics: action.payload.yearMetrics,
      }

    case metricsConstants.GET_RANGE_METRICS:
      return {
        ...state,
        rangeMetrics: action.payload,
      }

    case metricsConstants.GET_DRIVER_METRICS:
      return {
        ...state,
        driverMetrics: action.payload,
      }

    case metricsConstants.GET_COMPANY_METRICS:
      return {
        ...state,
        companyMetrics: action.payload,
      }

    case metricsConstants.GET_COMPANY_PROJECTION:
      return {
        ...state,
        companyProjectionMetrics: action.payload,
      }

    case 'GET_VEHICLE_METRICS':
      return {
        ...state,
        vehicleMetrics: action.payload,
      }

    default:
      return state
  }
}

export default metricsReducer
